import React, { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../constants';
import * as D from '../../deps';

import './AlbumGridItemThirdLine.scss';

interface IAlbumGridItemThirdLineOwnProps {
  Badge: ReactNode;
  mainText: string;
  mainTextUrl: string;
  preText: string;
}

type IAlbumGridItemThirdLineProps = IAlbumGridItemThirdLineOwnProps;

const AlbumGridItemThirdLine: React.FC<IAlbumGridItemThirdLineProps> = props => {
  const { preText, mainText, mainTextUrl, Badge } = props;

  const getText = (): ReactNode | null => {
    const MainLink =
      mainText && mainTextUrl ? (
        // @ts-expect-error TS(2322) FIXME: Type '{ children: any; className: string; to: any;... Remove this comment to see the full error message
        <D.Link className='AlbumGridItemThirdLine__text__link' to={mainTextUrl}>
          {mainText}
        </D.Link>
      ) : null;

    if (MainLink && preText) {
      return (
        <React.Fragment>
          <FormattedMessage {...messages.hyphen} values={{ preText }} /> {MainLink}
        </React.Fragment>
      );
    }

    return MainLink || preText;
  };

  const Text = getText();

  return (
    <div className='AlbumGridItemThirdLine'>
      {Text && <div className='AlbumGridItemThirdLine__text'>{Text}</div>}
      {Badge && <div className='AlbumGridItemThirdLine__badge'>{Badge}</div>}
    </div>
  );
};

export default AlbumGridItemThirdLine;
